import React, { useState } from 'react';

type Props = {
    ShowHidePopup: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    approveBtnTitle?: string;
    messageTitle?: string;
    messageContent: string;
    onPrevious?: Function;
};

export class ClientPopup extends React.Component<Props> {
    constructor(props:any) {
        super(props); 
    }

    componentDidMount(){
        this.load();
    }

    async load(){
    }

    closePopup = (status?: string)=>{
        if (this.props.ClosePopup) {
            this.props.ClosePopup(status);  
         }
    }

    approve = () => {
        if (this.props.OnApprove) {
            this.props.OnApprove();
        }
    }
    
    render() {
      return ( <>
        <div className="popup-wrapper small-warning">
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e:any)=>this.props.ShowHidePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {this.props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        {this.props.messageContent}
                    </div>
                    <div className="popup-footer">
                        { this.props.onPrevious ? 
                            (<>
                            
                            <button className="button blue blue-border" onClick={(e: any) => this.props.onPrevious && this.props.onPrevious()}>
                                חזור
                            </button>
                            </>) 
                            :
                            (<></>)
                        }
                        {
                            this.props.OnApprove ? 
                            (<>
                            
                            <button className="button blue blue-border" onClick={(e: any) => this.approve()}>
                                {this.props.approveBtnTitle ? this.props.approveBtnTitle : 'המשך'}
                            </button>
                            </>) 
                            :
                            (<></>)
                        }
                        <button className="button white blue-border"  onClick={(e:any)=>this.closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
      </>  
        
      );
    }
  }